import { roleAtLeast, type OrganisationRole } from '@ghostscreen/contracts';

/**
 * Create / edit playlists, content, schedules, screens, and design requests.
 * Mirrors the API's `content_manager` gate so we never offer an action it rejects.
 */
export function canManageContent(role: OrganisationRole | null | undefined): boolean {
  return role ? roleAtLeast(role, 'content_manager') : false;
}
